// Screenshot intent handler. Bridges UI_SCREENSHOT_SAVE → render-layer
// saveScenePNG so the UI never imports @render directly.

import { INTENTS } from '@store/intents';
import { saveScenePNG } from '@render/screenshot';
import type { Store } from '@store/store';
import type { State } from '@store/schema';
import type { ViewerContext } from '../context';

export function register(store: Store<State>, viewer: ViewerContext): Array<() => void> {
    return [
        store.onIntent(INTENTS.UI_SCREENSHOT_SAVE, () => {
            saveScenePNG(viewer);
        }),
    ];
}
